import { writable, get } from 'svelte/store';
import { Config } from '#lib/constants/config.js';
import { fetchWithRetry } from '$global/utils/fetchWithRetry/fetchWithRetry';

export const createTimeContext = () => {
	const loading = writable(true);
	const time = writable<null | number>(null);
	const updatedTime = writable<null | number>(null);
	const interval = writable<null | NodeJS.Timeout>(null);

	const fetchTime = async () => {
		loading.set(true);

		let currentTime: number | undefined;

		try {
			const currentTimeRes = await fetchWithRetry(`${Config.TimeDomain}`);
			({ time: currentTime } = await currentTimeRes.json());
		} catch {
			console.error('Failed to fetch time');
		}

		if (currentTime) {
			time.set(currentTime);
			updatedTime.set(currentTime);

			if (!get(interval)) {
				interval.set(
					setInterval(() => {
						updatedTime.update(($updatedTime) => {
							if ($updatedTime) {
								return $updatedTime + 1000;
							}

							return $updatedTime;
						});
					}, 1000)
				);
			}

			loading.set(false);
		}

		return Promise.resolve(currentTime);
	};

	return {
		loading,
		time,
		interval,
		updatedTime,
		fetchTime,
	};
};
